var render = function render(){var _vm=this,_c=_vm._self._c;return _c('texture-scene',{attrs:{"bgCorlor":_vm.bgCorlor,"url":_vm.imgurl,"envMap":_vm.envMap}})
}
var staticRenderFns = []

export { render, staticRenderFns }